<template>
  <div class="grid grid-cols-2">
    <button @click="view = APARTMENTS" class="px-8 py-4 text-left transition-colors duration-150 ease-in border-t-8 md:mr-1 bg-kas-100 border-kas-500 text-kas-500" :class="{ 'bg-opacity-50 border-opacity-0 text-opacity-75 hover:text-opacity-100': view !== APARTMENTS }">
      <span class="block text-lg font-bold uppercase sm:hidden">Vapaat</span>
      <span class="hidden text-lg font-bold uppercase sm:block">Vapaat vuokra-asunnot</span>
      <span class="hidden text-sm sm:block opacity-80">Osa asunnoista saattaa olla jo alustavasti varattu. </span>
    </button>

    <button @click="view = BUILDINGS" class="px-8 py-4 text-left transition-colors duration-150 ease-in border-t-8 md:ml-1 bg-kas-100 border-kas-500 text-kas-500" :class="{ 'bg-opacity-50 border-opacity-0 text-opacity-75 hover:text-opacity-100': view !== BUILDINGS }">
      <span class="block text-lg font-bold uppercase sm:hidden">Kaikki</span>
      <span class="hidden text-lg font-bold uppercase sm:block">Kaikki kohteet</span>
      <span class="hidden text-sm sm:block opacity-80">Voit selata kaikkia KAS asuntojen vuokrataloja. Huomioi, ettei asunto välttämättä ole vapaa.</span>
    </button>
  </div>


  <div class="px-8 py-4 bg-kas-100">
    <div class="flex items-center justify-center w-full h-32" v-if="optionsIsLoading">
      <Spinner />
    </div>

    <div class="flex flex-col grid-rows-3 gap-4 md:grid md:grid-rows-1 md:grid-cols-3 md:gap-16" v-if="options">
      <div>
        <div class="mb-8">
          <h2 class="mb-3 text-sm font-bold text-gray-700">Paikkakunta</h2>
          <Selecter :values="options.cities" :selected="city" placeholder="Näytä kaikki" @selected="value => city = value" />
        </div>

        <div v-if="view === APARTMENTS">
          <h2 class="flex items-center mb-3 text-sm font-bold text-gray-700">
            <label for="maxPrice" class="flex-1">Maks. vuokra</label>
            <span class="flex-grow-0">{{ maxPrice }} €</span>
          </h2>

          <div class="flex items-center">
            <span class="text-sm text-gray-700">150</span>
            <input id="maxPrice" class="flex-1 mx-3" type="range" min="150" max="1500" step="50" v-model.number="maxPrice">
            <span class="text-sm text-gray-700">1500</span>
          </div>
        </div>
      </div>
      <div>
        <h2 class="mb-3 text-sm font-bold text-gray-700">Talotyypit</h2>

        <div class="grid grid-cols-2 gap-4 mb-2 md:mb-8">
          <label v-for="option in options.buildingTypes" :key="option" class="flex items-center">
            <input class="cursor-pointer text-kas-500" type="checkbox" v-model="buildingTypes" :value="option" />
            <span class="pl-2 text-sm text-gray-700 cursor-pointer">{{ option }}</span>
          </label>
        </div>
      </div>
      <div>

        <h2 class="mb-3 text-sm font-bold text-gray-700">Huoneiston koko</h2>

        <div class="grid grid-cols-2 gap-4">
          <label v-for="option in options.numberOfRooms" :key="option" class="flex items-center">
            <input class="cursor-pointer text-kas-500" type="checkbox" v-model="numberOfRooms" :value="option" />
            <span class="pl-2 text-sm text-gray-700 cursor-pointer">{{ option }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <ApartmentList v-if="view === APARTMENTS"
                 :city="city"
                 :building-types="buildingTypes"
                 :max-price="maxPrice"
                 :number-of-rooms="numberOfRooms"
                 @toggleFavorite="apartment => toggleApartment(apartment)"
                 @resetOptions="resetOptions" />
  <BuildingList v-if="view === BUILDINGS"
                :city="city"
                :building-types="buildingTypes"
                :number-of-rooms="numberOfRooms"
                @toggleFavorite="building => toggleBuilding(building)"
                @resetOptions="resetOptions" />
</template>

<script>
import { computed, ref, watch } from 'vue'
import useOptions from '../use/options.js';
import useLoading from '../use/loading.js'
import ApartmentList from './ApartmentList'
import BuildingList from './BuildingList'
import Selecter from './Selecter'
import Spinner from './Spinner'

export default {
  name: 'PropertyFinder',
  components: { ApartmentList, BuildingList, Selecter, Spinner },
  setup() {
    const { isLoading } = useLoading()

    const view = ref(window.sessionStorage?.getItem('kas_open_tab') ?? 'apartments')
    const { city, buildingTypes, numberOfRooms, maxPrice, options, optionsIsLoading, toggleFavorite } = useOptions()

    watch(view, value => window.sessionStorage?.setItem('kas_open_tab', value))

    function resetOptions() {
      // city.value = null
      buildingTypes.value = []
      numberOfRooms.value = []
      maxPrice.value = 1500
    }

    function toggleApartment(apartment) {
      toggleFavorite({
        apartmentId: apartment.id,
        buildingId: apartment.building.id,
        streetAddress: apartment.building.street_address,
        postalCode: apartment.building.postal_code,
        postOffice: apartment.building.post_office,
        apartmentType: apartment.type,
        buildingType: apartment.building.type,
        area: apartment.area,
        price: apartment.price,
      })
    }

    function toggleBuilding(building) {
      toggleFavorite({
        apartmentId: null,
        buildingId: building.id,
        streetAddress: building.street_address,
        postalCode: building.postal_code,
        postOffice: building.post_office,
        apartmentType: null,
        buildingType: building.type,
        area: null,
        price: null,
      })
    }

    return {
      view,
      city,
      buildingTypes,
      numberOfRooms,
      maxPrice,
      options,
      resetOptions,
      optionsIsLoading,
      toggleApartment,
      toggleBuilding,
      anythingIsLoading: computed(() => isLoading()),
      APARTMENTS: 'apartments',
      BUILDINGS: 'buildings',
    }
  }
}
</script>
